export const AuthoritySection = () => {
    return (
        <section className="authority-section">
            <div className="container">
                <p className="text-center" style={{ marginBottom: '2rem', color: '#6c757d', fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '2px', fontWeight: '600' }}>
                    Experiencia y Respaldo Institucional
                </p>
                <div className="slider-container">
                    <div className="slider-track">
                        {/* Original Itemss */}
                        <div className="authority-logo-text">AFIP</div>
                        <div className="authority-logo-text">RENTAS CORRIENTES</div>
                        <div className="authority-logo-text">CPCE</div>
                        <div className="authority-logo-text">MINISTERIO DE TRABAJO</div>

                        {/* Duplicated Items for Infinite Scroll */}
                        <div className="authority-logo-text">AFIP</div>
                        <div className="authority-logo-text">RENTAS CORRIENTES</div>
                        <div className="authority-logo-text">CPCE</div>
                        <div className="authority-logo-text">MINISTERIO DE TRABAJO</div>

                        {/* Duplicated Items Phase 2 */}
                        <div className="authority-logo-text">AFIP</div>
                        <div className="authority-logo-text">RENTAS CORRIENTES</div>
                        <div className="authority-logo-text">CPCE</div>
                        <div className="authority-logo-text">MINISTERIO DE TRABAJO</div>
                    </div>
                </div>
            </div>
        </section>
    );
};
